export class ErrorResponse {
  message: string;
  error: any;
}
